"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ListItem_1 = require("@mui/material/ListItem");
var ListItemText_1 = require("@mui/material/ListItemText");
var ListItemAvatar_1 = require("@mui/material/ListItemAvatar");
var Avatar_1 = require("@mui/material/Avatar");
var Delete_1 = require("@mui/icons-material/Delete");
var Edit_1 = require("@mui/icons-material/Edit");
var Download_1 = require("@mui/icons-material/Download");
var Article_1 = require("@mui/icons-material/Article");
var Divider_1 = require("@mui/material/Divider");
var IconButton_1 = require("@mui/material/IconButton");
var Document_1 = require("../models/Document");
var react_1 = require("react");
var GenericModal_1 = require("./GenericModal");
var Role_1 = require("../shared/utilities/Role");
function Document(props) {
    var role = Role_1.default();
    var _a = React.useState(false), expanded = _a[0], setExpanded = _a[1];
    var deleteModalRef = react_1.useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement(ListItem_1.default, { sx: { paddingRight: '90px' }, secondaryAction: React.createElement(React.Fragment, null,
                React.createElement(IconButton_1.default, { edge: "end", "aria-label": "comments", onClick: function () {
                        var fileType = props.documentLocation.split('.').pop();
                        fetch(props.documentLocation, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/' + fileType,
                            },
                        })
                            .then(function (response) { return response.blob(); })
                            .then(function (blob) {
                            var _a;
                            // Create blob link to download
                            var url = window.URL.createObjectURL(new Blob([blob]));
                            var link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', props.name + "." + fileType);
                            // Append to html link element page
                            document.body.appendChild(link);
                            // Start download
                            link.click();
                            // Clean up and remove the link
                            (_a = link.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(link);
                        });
                    } },
                    React.createElement(Download_1.default, null)),
                role === 'Admin' &&
                    React.createElement(IconButton_1.default, { edge: "end", "aria-label": "comments", onClick: function () {
                            var document = new Document_1.DocumentModel();
                            document.DocumentId = props.id;
                            document.Name = props.name;
                            document.Description = props.description;
                            document.DocumentLocation = props.documentLocation;
                            document.DisplaySequence = props.displaySequence;
                            props.openDocumentModal(document);
                        } },
                        React.createElement(Edit_1.default, null)),
                role === 'Admin' &&
                    React.createElement(IconButton_1.default, { edge: "end", "aria-label": "comments", onClick: function () {
                            var _a;
                            deleteModalRef && ((_a = deleteModalRef === null || deleteModalRef === void 0 ? void 0 : deleteModalRef.current) === null || _a === void 0 ? void 0 : _a.handleOpen());
                        } },
                        React.createElement(Delete_1.default, null))) },
            React.createElement(ListItemAvatar_1.default, null,
                React.createElement(Avatar_1.default, null,
                    React.createElement(Article_1.default, null))),
            React.createElement(ListItemText_1.default, { primary: props.name, secondary: props.description })),
        React.createElement(Divider_1.default, null),
        React.createElement(GenericModal_1.default, { ref: deleteModalRef, text: 'Are you sure you want to delete ' + props.name + ' document?', action: props.delete, value: props.id })));
}
exports.default = Document;
//# sourceMappingURL=Document.js.map